import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { EbisInterfaceMonitoringMaintenanceProvider } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import EbisInterfaceMonitoringMaintenance from "presentation/view/section/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const EbisInterfaceMonitoringMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.EBIS_INTERFACE_MONITORING_MAINTENANCE}>
        <MessageBarWrapper>
            <EbisInterfaceMonitoringMaintenanceProvider>
                <GridStyles/>
                <EbisInterfaceMonitoringMaintenance/>
            </EbisInterfaceMonitoringMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default EbisInterfaceMonitoringMaintenanceCont;